/**
 * Severity — minimal severity indicator.
 *
 * - <Severity level="critical"> compact pill (rarely used)
 * - <SeverityDot level="critical" /> 8px dot (preferred)
 *
 * Confidence: text colour helper.
 */

const NORMALISE = (s) => (s ? String(s).toLowerCase() : "low");

export function SeverityDot({ level = "low", className = "" }) {
    const lvl = NORMALISE(level);
    return (
        <span
            className={`sev-dot ${lvl} ${className}`.trim()}
            aria-label={`severity ${lvl}`}
        />
    );
}

export function Severity({ level = "low", label, className = "" }) {
    const lvl = NORMALISE(level);
    return (
        <span
            className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium sev-${lvl} ${className}`.trim()}
            data-testid={`severity-${lvl}`}
        >
            <SeverityDot level={lvl} />
            {label ?? lvl}
        </span>
    );
}

export function Confidence({ level = "medium", className = "" }) {
    const lvl = NORMALISE(level);
    const cls = { high: "conf-high", medium: "conf-medium", low: "conf-low" }[lvl] || "conf-medium";
    return (
        <span className={`text-[12px] font-medium ${cls} ${className}`.trim()}>
            {lvl} confidence
        </span>
    );
}
